import { collection, getDocs, query, where } from 'firebase/firestore'
import { db } from '../../db'

export async function getHighestQueuePosition(
  doctorId: string,
  date: string
): Promise<number> {
  const snapshot = await getDocs(
    query(
      collection(db, 'queue'),
      where('doctorId', '==', doctorId),
      where('date', '==', date)
    )
  )
  return snapshot.docs.reduce(
    (highest, entry) => Math.max(highest, Number(entry.data().position ?? 0)),
    0
  )
}
